<!-- ══════════════════════════════════════════════════════════════
Encabezado
═══════════════════════════════════════════════════════════════ -->

<app-page-title [title]="title()"></app-page-title>
<app-page-loader [load]="pageLoad" [label]="title()" (retry)="init()"></app-page-loader>

<!-- ══════════════════════════════════════════════════════════════
Buscador + Tabla
═══════════════════════════════════════════════════════════════ -->
<div class="table-section">

  <div class="filter-bar filter-bar--flush">
    <div class="filter-card">
      <app-search-pill [value]="searchText()" placeholder="Nombre, etiqueta, ruta…" (search)="onSearch($event)"></app-search-pill>
      <mat-button-toggle-group class="view-toggle" [value]="listView.mode" (change)="listView.set($event.value)" [hideSingleSelectionIndicator]="true" aria-label="Vista">
      <mat-button-toggle value="table" matTooltip="Vista de tabla"><mat-icon>table_rows</mat-icon></mat-button-toggle>
      <mat-button-toggle value="cards" matTooltip="Vista de tarjetas"><mat-icon>grid_view</mat-icon></mat-button-toggle>
    </mat-button-toggle-group>
    </div>
    <app-filter-chips [count]="dataSource.filteredData.length" [total]="dataSource.data.length" noun="módulos"></app-filter-chips>
  </div>

  <div class="list-actions">
    <button mat-stroked-button (click)="pageLoad.refresh(loadModules())"><mat-icon>refresh</mat-icon> Actualizar</button>
    <button mat-flat-button color="primary" (click)="openCreate()">
      <mat-icon>add</mat-icon> Nuevo Módulo
    </button>
  </div>

  <app-selection-bar [count]="sel.count" (export)="exportExcel(sel.selected)" (clear)="sel.clear()"></app-selection-bar>

  <mat-paginator [hidden]="listView.mode !== 'table'" [pageSize]="10" [pageSizeOptions]="[5, 10, 25]" showFirstLastButtons></mat-paginator>

  @if (loading()) {
    <div class="loading-row">
      <mat-spinner diameter="36"></mat-spinner>
      <span>Cargando módulos...</span>
    </div>
  }


  @if (listView.mode === 'cards') {
    <div class="inv-cards cat-cards">
      @for (m of dataSource.filteredData; track $index) {
        <div class="cat-card" [class.cat-card--selected]="sel.isSelected(m)">
          <div class="cat-card__head">
            <mat-checkbox color="primary" [checked]="sel.isSelected(m)" (change)="sel.toggle(m)" matTooltip="Seleccionar"></mat-checkbox>
            <div class="icon-chip"><mat-icon>{{ m.icon || 'widgets' }}</mat-icon></div>
            <span class="cat-card__title">{{ m.label || m.name }}</span>
          </div>
          <div class="cat-card__body">
            <div class="cat-card__field"><span class="cat-card__label">Nombre:</span><span class="cat-card__value">{{ m.name }}</span></div>
            @if (m.description) {<div class="cat-card__field"><span class="cat-card__label">Descripción:</span><span class="cat-card__value">{{ m.description }}</span></div>}
            <div class="cat-card__field"><span class="cat-card__label">Ruta:</span><span class="cat-card__value"><code class="route-badge">{{ m.route ?? '—' }}</code></span></div>
          </div>
          <div class="cat-card__actions">
            <mat-slide-toggle [checked]="m.active" (change)="toggleActive(m)" color="primary" [matTooltip]="m.active ? 'Activo — click para desactivar' : 'Inactivo — click para activar'"></mat-slide-toggle>
            <span class="spacer"></span>
            <button mat-icon-button color="primary" matTooltip="Editar" (click)="openEdit(m)"><mat-icon>edit</mat-icon></button>
          </div>
        </div>
      }
      @if (dataSource.filteredData.length === 0) {
        <p class="inv-cards__empty">Sin resultados</p>
      }
    </div>
  }

  <div class="table-container mat-elevation-z2" [hidden]="listView.mode !== 'table'">
    <table mat-table [dataSource]="dataSource">

      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef class="select-cell">
          <mat-checkbox color="primary" (change)="$event ? sel.toggleAll() : null" [checked]="sel.allSelected()" [indeterminate]="sel.someSelected()" matTooltip="Seleccionar todos los visibles"></mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row" class="select-cell">
          <mat-checkbox color="primary" (click)="$event.stopPropagation()" (change)="$event ? sel.toggle(row) : null" [checked]="sel.isSelected(row)"></mat-checkbox>
        </td>
      </ng-container>

      <!-- Ícono -->
      <ng-container matColumnDef="icon">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let m">
          <div class="icon-chip">
            <mat-icon>{{ m.icon || 'widgets' }}</mat-icon>
          </div>
        </td>
      </ng-container>

      <!-- Nombre -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Nombre</th>
        <td mat-cell *matCellDef="let m">
          <div class="name-cell">
            <span class="name">{{ m.name }}</span>
            @if (m.description) {
              <span class="desc">{{ m.description }}</span>
            }
          </div>
        </td>
      </ng-container>

      <!-- Etiqueta -->
      <ng-container matColumnDef="label">
        <th mat-header-cell *matHeaderCellDef>Etiqueta</th>
        <td mat-cell *matCellDef="let m">{{ m.label ?? '—' }}</td>
      </ng-container>

      <!-- Ruta -->
      <ng-container matColumnDef="route">
        <th mat-header-cell *matHeaderCellDef>Ruta</th>
        <td mat-cell *matCellDef="let m">
          <code class="route-badge">{{ m.route ?? '—' }}</code>
        </td>
      </ng-container>

      <!-- Activo -->
      <ng-container matColumnDef="active">
        <th mat-header-cell *matHeaderCellDef>Estado</th>
        <td mat-cell *matCellDef="let m">
          <mat-slide-toggle
            [checked]="m.active"
            (change)="toggleActive(m)"
            color="primary"
            [matTooltip]="m.active ? 'Activo — click para desactivar' : 'Inactivo — click para activar'">
          </mat-slide-toggle>
        </td>
      </ng-container>

      <!-- Acciones -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let m">
          <button mat-icon-button color="primary" matTooltip="Editar"
            (click)="openEdit(m)">
            <mat-icon>edit</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: columns;" class="table-row"></tr>

      <tr class="no-data-row" *matNoDataRow>
        <td [attr.colspan]="columns.length">
          <div class="no-data">
            <mat-icon>search_off</mat-icon>
            <span>No se encontraron módulos</span>
          </div>
        </td>
      </tr>
    </table>
  </div>


</div>